<template>
  <div class="upload-box">
    <div class='h100-60 noPage'>
      <ejs-grid ref='grid' height='calc(100% - 20px)'>
        <e-columns>
          <e-column field="nodeName" :headerText="$t('DeployManagement.nodeName')" width='100' textAlign="Center" clipMode='EllipsisWithTooltip'/>
          <e-column field="serviceName" :headerText="$t('DeployManagement.neName')" width='100' textAlign="Center" clipMode='EllipsisWithTooltip'/>
          <e-column field="status" :headerText="$t('DeployManagement.upgradeStatus')" width='60' textAlign="Center" clipMode='EllipsisWithTooltip'/>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import {EventBus} from "../../../../../plugins/eventBus";

export default {
  name: 'UpgradeInfos',
  components: {
  },
  data() {
    return {
      selected:[],
      envId:'',
      timer:'',
      stateMap: {
        "-1": this.$t('DeployManagement.nooperation'),
        "0": this.$t('DeployManagement.rolllbackable'),
        "1": this.$t('DeployManagement.upgradeable'),
        "2":this.$t('DeployManagement.upgrading'),
        "3": this.$t('DeployManagement.rollbacking'),
        "4": this.$t('DeployManagement.fail'),
      },
    };
  },
  methods: {
    qryUpgradeInfos(){
      this.axios.post('/lte/ems/packageManager/upgradeStatsInfos', {envId:this.envId}).then((res) =>{
        if(res.data.errorCode == 'SUCCESS' && res.data.resultVal){
          let showData = [];
          res.data.resultVal.forEach(item =>{
            if(this.selected.length > 0){
              this.selected.forEach(target =>{
                if(item.id == target.dpId){
                  showData.push({nodeName:item.nodeName,serviceName:item.serviceName,status:this.stateMap[item.status]})
                }
              });
            }else{
              showData.push({nodeName:item.nodeName,serviceName:item.serviceName,status:this.stateMap[item.status]})
            }
          });
          this.$refs.grid.ej2Instances.dataSource = showData;
        }else{
          EventBus.$emit('toast', { type: 'error', content: res.data.errorString });
        }
      });
    },
    setUpgradeInfo(param) {
      console.log(param);
      this.envId = param.envId;
      this.selected = param.selected;
      this.$refs.grid.ej2Instances.dataSource = [];
      this.qryUpgradeInfos();
      this.timer = setInterval(this.qryUpgradeInfos, 15000);
    },
  },
  mounted() {
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
